import { useState, useEffect } from 'react';
import moment from 'moment';

const int = 1000;

export const Countdown = ({
  date,
  renderer,
}) => {
  const [state, setstate] = useState({
    completed: false,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  let completed = false;

  useEffect(() => {
    const interval = setInterval(() => {
      const diffTime = moment(date).diff(moment());

      const duration = moment.duration(diffTime, 'milliseconds');
      if (diffTime <= 0) {
        completed = true;
        clearInterval(interval);
      }

      setstate({
        ...state,
        completed,
        days: duration.days(),
        hours: duration.hours(),
        minutes: duration.minutes(),
        seconds: duration.seconds(),
      });
    }, int);

    return () => clearInterval(interval);
  }, [date, state]);
  return renderer(state);
};
